import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Fragment } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import EditorContext from '../../containers/editor-context';
var AddLinkDialog = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AddLinkDialog, _React$PureComponent);
  var _super = _createSuper(AddLinkDialog);
  function AddLinkDialog(props) {
    var _this;
    _classCallCheck(this, AddLinkDialog);
    _this = _super.call(this, props);
    _this.setInitialValue = function () {
      var text = _this.editorUtils.getSelectedText();
      if (_this.isLinkActive) {
        var linkNode = _this.editorUtils.getCurrentLinkNode();
        _this.setState({
          title: _this.editorUtils.getLinkText(linkNode),
          url: linkNode.data.href
        });
      } else {
        _this.setState({
          title: text,
          url: ''
        });
      }
    };
    _this.handleUrlChange = function (event) {
      _this.setState({
        url: event.target.value
      });
    };
    _this.handleTitleChange = function (event) {
      _this.setState({
        title: event.target.value
      });
    };
    _this.handleSubmit = function (event) {
      event.preventDefault();
      if (_this.state.title.length === 0 || _this.state.url.length === 0) return;
      if (!_this.isLinkActive) {
        _this.editorUtils.insertLink({
          text: _this.state.title,
          url: _this.state.url,
          selection: _this.editorSelection
        });
      } else {
        _this.editorUtils.setLink({
          text: _this.state.title,
          url: _this.state.url,
          selection: _this.editorSelection
        });
      }
      _this.props.toggleLinkDialog();
    };
    _this.onKeyDown = function (e) {
      if (e.keyCode === 13) {
        _this.handleSubmit(e);
      }
    };
    _this.editorUtils = EditorContext.getEditorUtils();
    _this.isLinkActive = _this.editorUtils.isLinkActive();
    _this.editorSelection = null;
    _this.state = {
      url: '',
      title: ''
    };
    return _this;
  }
  _createClass(AddLinkDialog, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.setInitialValue();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var editor = EditorContext.getEditor();
      this.editorSelection = editor.selection;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Modal, {
        isOpen: true,
        autoFocus: false,
        toggle: this.props.toggleLinkDialog,
        className: this.props.className,
        zIndex: 1071,
        returnFocusAfterClose: false
      }, /*#__PURE__*/React.createElement(ModalHeader, {
        toggle: this.props.toggleLinkDialog
      }, this.props.t('insert_link')), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("label", {
        className: "form-check-label",
        htmlFor: "addLink"
      }, this.props.t('link_address')), /*#__PURE__*/React.createElement("input", {
        onKeyDown: this.onKeyDown,
        autoFocus: true,
        type: "url",
        className: "form-control",
        id: "addLink",
        value: this.state.url,
        onChange: this.handleUrlChange
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("label", {
        className: "form-check-label",
        htmlFor: "addTitle"
      }, this.props.t('link_title')), /*#__PURE__*/React.createElement("input", {
        onKeyDown: this.onKeyDown,
        type: "text",
        className: "form-control",
        id: "addTitle",
        value: this.state.title,
        onChange: this.handleTitleChange
      })))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
        color: "secondary",
        onClick: this.props.toggleLinkDialog
      }, this.props.t('cancel')), /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        disabled: false,
        onClick: this.handleSubmit
      }, this.props.t('add_link'))));
    }
  }]);
  return AddLinkDialog;
}(React.PureComponent);
export default withTranslation('seafile-editor')(AddLinkDialog);